import { PropsWithChildren } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { Drawer, MobileDrawer, SideNavbarWrapper } from './SideNavbar.styles';
import { SideNavProvider } from './SideNavContext';

export interface SideNavbarProps {
  readonly open?: boolean;
  readonly onClose?: () => void;
  readonly onMouseOver?: () => void;
}

export function SideNavbar({
  open,
  onClose,
  onMouseOver,
  children,
}: PropsWithChildren<SideNavbarProps>) {
  const { isMdUp } = useBreakpoints();

  const expanded = Boolean(open);

  if (isMdUp) {
    return (
      <Drawer
        anchor="left"
        onClose={onClose}
        onFocus={onMouseOver}
        onMouseLeave={onClose}
        onMouseOver={onMouseOver}
        open={open}
        variant="permanent"
      >
        <SideNavProvider expanded={expanded}>
          <SideNavbarWrapper>{children}</SideNavbarWrapper>
        </SideNavProvider>
      </Drawer>
    );
  }

  return (
    <MobileDrawer anchor="left" onClose={onClose} open={open}>
      <SideNavProvider expanded onLinkClick={onClose}>
        <SideNavbarWrapper>{children}</SideNavbarWrapper>
      </SideNavProvider>
    </MobileDrawer>
  );
}
